const namespace = "LEAD_CAPTURE_";

export default {
  SUBMIT_LEAD_DATA: `${namespace}SUBMIT_LEAD_DATA`,
  LEAD_LOADER: `${namespace}LEAD_LOADER`,
  LEAD_SUCCESS: `${namespace}LEAD_SUCCESS`,
  LEAD_FAILURE: `${namespace}LEAD_FAILURE`,
};
